/*
 *  -----------------------------------------------------------------------
 *    <copyright file="risk.service.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

const RiskService = {
    reviewFrequencyNumberMin: 1,
    reviewFrequencyNumberMax: 31,
    timeFrequencyListObject: [
        {
            id: 'DAILY',
            text: 'Day(s)',
        },
        {
            id: 'WEEKLY',
            text: 'Week(s)',
        },
        {
            id: 'MONTHLY',
            text: 'Month(s)',
        },
        {
            id: 'QUARTERLY',
            text: 'Quarter(s)',
        },
        {
            id: 'ANNUALLY',
            text: 'Year(s)',
        },
    ],
    riskStatusList: [
        {
            id: 'DRAFT',
            text: 'Draft',
        },
        {
            id: 'IDENTIFIED',
            text: 'Identified',
        },
        {
            id: 'ASSESSED',
            text: 'Assessed',
        },
        {
            id: 'CONTROLLED',
            text: 'Controlled',
        },
        {
            id: 'TRIGGERED',
            text: 'Triggered',
        },
        {
            id: 'CLOSED',
            text: 'Closed',
        },
        {
            id: 'NOT_APPLICABLE',
            text: 'Not Applicable',
        },
        {
            id: 'OBSOLETE',
            text: 'Obsolete',
        },
    ],
};

export enum MOVEMENT_STATE {
    rising = 'rising',
    falling = 'falling',
    stable = 'stable',
}

export { RiskService };
